import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonBaseProps {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  icon?: boolean;
  children?: React.ReactNode;
  className?: string;
}
interface ButtonAsButton extends ButtonBaseProps, React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: never;
  target?: never;
}
interface ButtonAsLink extends ButtonBaseProps {
  href: string;
  target?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}
type ButtonProps = ButtonAsButton | ButtonAsLink;
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  icon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4836B] no-underline';
  const variants = {
    primary: 'bg-[#D4836B] hover:bg-[#C4735B] text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-white border-2 border-[#D4836B] text-[#D4836B] hover:bg-[#FFF5F2]'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if ('href' in props && props.href) {
    const {
      href,
      target,
      ...rest
    } = props as ButtonAsLink;
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} className={combinedClassName} {...rest} data-id="element-115">
        {children}
        {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-116" />}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClassName} {...props as React.ButtonHTMLAttributes<HTMLButtonElement>} data-id="element-117">
      {children}
      {icon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-118" />}
    </motion.button>;
}